import axios from 'axios'
import { useState, useEffect } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovaQuestao.css'

export default function Modal({ setOpenModal, modalInfo }) {

    var user = authService.getCurrentUser()
    let newDate = new Date()
    const [campos, setCampos] = useState({
        IdObservacaoQuestao: modalInfo.IdObservacaoQuestao,
        IdObservacaoGrupo: modalInfo.IdObservacaoGrupo,
        IdObservacaoSubGrupo: modalInfo.IdObservacaoSubGrupo,
        IdObservacaoTipo: modalInfo.IdObservacaoTipo,
        IdEmpresa: modalInfo.IdEmpresa,
        oqsNumero: modalInfo.oqsNumero,
        oqsDescricao: modalInfo.oqsDescricao,
        oqsStatus: parseInt(modalInfo.oqsStatus),
        oqsObservacoes: modalInfo.oqsObservacoes,
        oqsAlteradoPor: user[0].pesEmail,
        oqsAlteradoEm: newDate
    })

    const [observacaoGrupos, setObservacaoGrupos] = useState([])
    useEffect(() => {
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/observacaogrupo/listgrupos/' +
                modalInfo.IdObservacaoTipo
            )
            .then(response => {
                if (response.status === 200) {
                    setObservacaoGrupos(response.data)
                } else {
                    alert(response.data.message)
                }
            })
            setContagem(campos.oqsDescricao.length)
    }, [modalInfo.IdObservacaoTipo])
    const [observacaoSubGrupos, setObservacaoSubGrupos] = useState([])
    useEffect(() => {
        axios
            .get(
                process.env.REACT_APP_API_URL +
                '/api/v1/observacaosubgrupo/list/' +
                modalInfo.IdObservacaoGrupo
            )
            .then(response => {
                if (response.status === 200) {
                    setObservacaoSubGrupos(response.data)
                } else {
                    alert(response.data.message)
                }
            })
    }, [modalInfo.IdObservacaoGrupo])

    const [contagem, setContagem] = useState(0)
    function handleInputChange(event) {
        if (event.target.name === 'oqsStatus') {
            if (event.target.checked === true) {
                campos[event.target.name] = 1
            } else {
                campos[event.target.name] = 0
            }
        } else {
            campos[event.target.name] = event.target.value
        }
        setCampos(campos)
        setContagem(campos.oqsDescricao.length)

        if (event.target.name === 'IdObservacaoGrupo') {
            axios
                .get(
                    process.env.REACT_APP_API_URL +
                    '/api/v1/observacaosubgrupo/list/' +
                    event.target.value
                )
                .then(response => {
                    if (response.status === 200) {
                        setObservacaoSubGrupos(response.data)
                    } else {
                        alert(response.data.message)
                    }
                })
        }
        
    }
    function handleFormSubmit(event) {
        event.preventDefault()
        axios
            .post(
                process.env.REACT_APP_API_URL +
                '/api/v1/observacaoquestao/' +
                modalInfo.IdObservacaoQuestao,
                campos
            )
            .then(response => {
                if (response.status === 200) {
                    alert(response.data.message)
                    window.location.reload()
                } else {
                    alert(response.data.message)
                }
            })
    }
    //console.log('campos:', campos) // Adicione esta linha para depuração
    return (
        <>
            <div className="overlay">
                <div className="modalPadrao-content">
                    <div className="cxTituloPadrao">
                        <h1>
                            Editar Questão
                            <hr className="hrTitleModal" />
                        </h1>
                        <button className="close-modal" onClick={() => { setOpenModal(false) }}>
                            X
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmit}>
                        <div className="linhaTipObs" style={{ width: '100%' }}>
                            <tr>
                                <th><label>Ordem</label></th>
                                <th><label>Texto da Questão:</label></th>
                            </tr>
                            <tr>
                                <td valign='top'>
                                    <input
                                        type="number"
                                        id="oqsNumero"
                                        name="oqsNumero"
                                        onChange={handleInputChange}
                                        defaultValue={campos.oqsNumero}
                                    ></input>
                                </td>
                                <td style={{ width: 780 }}>
                                    <textarea
                                        type="text"
                                        id="oqsDescricao"
                                        name="oqsDescricao"
                                        rows={3}
                                        maxLength="256"
                                        onChange={handleInputChange}
                                        defaultValue={campos.oqsDescricao}
                                    ></textarea>
                                    <br />
                                    {contagem}/256 caracteres
                                </td>
                            </tr>
                            {/* linha com um dropdown que exibe os grupos de questoes e tras selecionado o valor de modalInfo o IdGrupo e caso seja zero exibe como texto no lugar selecione um grupo. */}
                            <tr>
                                <th><label>Grupo:</label></th>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <select
                                        id="IdObservacaoGrupo"
                                        name="IdObservacaoGrupo"
                                        onChange={handleInputChange}
                                        value={campos.IdObservacaoGrupo}
                                        defaultValue={campos.IdObservacaoGrupo}
                                    >
                                        <option value={0}>Selecione um Grupo</option>
                                        {observacaoGrupos.map((grupo) => (
                                            <option key={grupo.IdObservacaoGrupo} value={grupo.IdObservacaoGrupo}>
                                                {grupo.ogrDescricao}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                            {/* linha com um dropdown que exibe os subgrupos de questoes e tras selecionado o valor de modalInfo o IdSubGrupo 
                            e caso seja zero exibe como texto no lugar selecione um subGrupo. */}
                            <tr>
                                <th><label>Sub Grupo:</label></th>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <select
                                        id="IdObservacaoSubGrupo"
                                        name="IdObservacaoSubGrupo"
                                        onChange={handleInputChange}
                                        value={campos.IdObservacaoSubGrupo}
                                        defaultValue={campos.IdObservacaoSubGrupo}
                                    >
                                        <option value={0}>Selecione um Sub Grupo</option>
                                        {observacaoSubGrupos.map((subGrupo) => (
                                            <option key={subGrupo.IdObservacaoSubGrupo} value={subGrupo.IdObservacaoSubGrupo}>
                                                {subGrupo.sbgDescricao}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        </div>

                        <label>
                            Observações:
                        </label>
                        <textarea
                            type="text"
                            id="oqsObservacoes"
                            name="oqsObservacoes"
                            row="none"
                            maxLength="500"
                            onChange={handleInputChange}
                            defaultValue={campos.oqsObservacoes}
                        ></textarea>
                        <div className="caixaSalvarPadrao">
                            <div className="InputAuthorization1">
                                <label>
                                    <input
                                        name="oqsStatus"
                                        type="checkbox"
                                        onChange={handleInputChange}
                                        defaultChecked={!!campos.oqsStatus} />
                                    <span style={{ position: 'relative' }}>
                                        Status do Registro
                                    </span>
                                </label>
                            </div>
                            <button type="submit" className="gravar-modal">
                                Salvar Questão
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
